"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationDiscriminator = exports.IntegrationKind = exports.IntegrationType = void 0;
var IntegrationType;
(function (IntegrationType) {
    IntegrationType["AUTH"] = "Auth";
    IntegrationType["PROVISIONING"] = "Provisioning";
    IntegrationType["NOTIFICATION"] = "Notification";
})(IntegrationType = exports.IntegrationType || (exports.IntegrationType = {}));
exports.IntegrationKind = (_a = {},
    _a[IntegrationType.AUTH] = {
        SAML: 'SAML',
    },
    _a[IntegrationType.PROVISIONING] = {
        EWS: 'EWS',
        GWC: 'GWC',
        TEAMS: 'TEAMS',
        O365_CALENDAR: 'O365_CALENDAR',
    },
    _a[IntegrationType.NOTIFICATION] = {
        SLACK: 'SLACK',
    },
    _a);
var IntegrationDiscriminator;
(function (IntegrationDiscriminator) {
    IntegrationDiscriminator["AUTH_SAML"] = "SAMLIntegration";
    IntegrationDiscriminator["PROVISION_EWS"] = "EWSIntegration";
    IntegrationDiscriminator["NOTIFICATION_SLACK"] = "SlackIntegration";
    IntegrationDiscriminator["GOOGLE_WORKSPACE_CALENDAR"] = "GoogleWorkspaceCalendar";
    IntegrationDiscriminator["O365_CALENDAR"] = "O365Calendar";
    IntegrationDiscriminator["TEAMS"] = "Teams";
})(IntegrationDiscriminator = exports.IntegrationDiscriminator || (exports.IntegrationDiscriminator = {}));
